import { useDailySales } from "../../../../../hooks/metrics/useDailySales";
import { useModuleEnabled } from "../../../../../hooks/gym/useModuleEnabled";
import { getAllSales } from "../../../../../utils/sidebar";
import { SaleItem } from "./item";

export const DailySalesNotifications = () => {
  const includePlans = useModuleEnabled("planSales");
  const includeFood = useModuleEnabled("foodSales");
  const includeMerchandise = useModuleEnabled("merchandiseSales");

  const hasAnySalesModule = includePlans || includeFood || includeMerchandise;
  const { data, isLoading, error } = useDailySales({
    enabled: hasAnySalesModule,
  });

  if (!hasAnySalesModule) return null;

  if (isLoading) {
    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between px-0.5">
          <div className="flex items-center gap-1.5">
            <svg
              className="w-3.5 h-3.5 text-global-accent"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
            <h3 className="text-size-2xs font-semibold text-global-secondary uppercase tracking-wide">
              Ventas diarias
            </h3>
          </div>
        </div>
        <div className="bg-global-overlay-secondary rounded-md p-3 border border-global-secondary text-center">
          <p className="text-size-2xs text-global-muted">Cargando...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between px-0.5">
          <div className="flex items-center gap-1.5">
            <svg
              className="w-3.5 h-3.5 text-global-accent"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
            <h3 className="text-size-2xs font-semibold text-global-secondary uppercase tracking-wide">
              Ventas diarias
            </h3>
          </div>
        </div>
        <div className="bg-(--color-error-bg) rounded-md p-3 border border-(--color-error-border) text-center">
          <p className="text-size-2xs text-(--color-error-text)">
            {error.message}
          </p>
        </div>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const allSales = getAllSales(data, {
    includePlans,
    includeFood,
    includeMerchandise,
  });

  const totalSales = allSales.length;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between px-0.5">
        <div className="flex items-center gap-1.5">
          <svg
            className="w-3.5 h-3.5 text-global-accent"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            />
          </svg>
          <h3 className="text-size-2xs font-semibold text-global-secondary uppercase tracking-wide">
            Ventas diarias
          </h3>
        </div>
        <span className="px-1.5 py-0.5 bg-global-accent/20 text-global-accent rounded text-size-2xs font-bold">
          {totalSales}
        </span>
      </div>

      {totalSales === 0 ? (
        <div className="bg-global-overlay-secondary rounded-md p-3 border border-global-secondary text-center">
          <p className="text-size-2xs text-global-muted">
            No hay ventas registradas hoy
          </p>
        </div>
      ) : (
        <div className="space-y-1 max-h-48 overflow-y-auto custom-scrollbar">
          {allSales.map((sale, index) => (
            <SaleItem
              key={`${sale.type}-${sale.clientName}-${sale.time}-${index}`}
              sale={sale}
            />
          ))}
        </div>
      )}
    </div>
  );
};
